import Hero from "./Hero";
import About from "./About";
import Experience from "./Experience";
import Work from "./Work";
import Contact from "./Contact";
import "./App.css";

function App() {
  return (
    <div>
      <header className="d-flex justify-content-end py-3">
        <ul className="nav nav-pills">
          <li className="nav-item">
            <a href="#about" class="nav-link">
              About
            </a>
          </li>
          <li className="nav-item">
            <a href="#Experience" className="nav-link">
              Experience
            </a>
          </li>
          <li className="nav-item">
            <a href="#Work" className="nav-link">
              Work
            </a>
          </li>
          <li className="nav-item">
            <a href="#contact" className="nav-link">
              Contact
            </a>
          </li>
          <button class="btn btn-outline-info" type="submit">
            Resume
          </button>
        </ul>
      </header>
      <div className="container px-4">
        <section>
          <Hero />
        </section>
        <section>
          <About />
        </section>
        <section>
          <Experience />
        </section>
        <section>
          <Work />
        </section>
        <section>
          <Contact />
        </section>
      </div>
      <footer class="py-3 my-4">
        <ul class="nav justify-content-center border-bottom pb-3 mb-3">
          <li class="nav-item">
            <a href="#about" class="nav-link px-2 text-body-secondary">
              About
            </a>
          </li>
          <li class="nav-item">
            <a href="#Experience" class="nav-link px-2 text-body-secondary">
              Experience
            </a>
          </li>
          <li class="nav-item">
            <a href="#Work" class="nav-link px-2 text-body-secondary">
              Work
            </a>
          </li>
          <li class="nav-item">
            <a href="#Contact" class="nav-link px-2 text-body-secondary">
              Contact
            </a>
          </li>
        </ul>
        <div className="text-center row justify-content-center">
          <div className="col-1">
            <a href="https://github.com/Annekaka" className="nav-link">
              Github
            </a>
          </div>
          <div className="col-1">
            <a
              href="https://www.linkedin.com/in/anne-helene-nergård-87472b260/"
              className="nav-link"
            >
              Linkedin
            </a>
          </div>
          <div className="col-1">
            <a
              href="https://friendly-kleicha-42d182.netlify.app"
              className="nav-link"
            >
              Netlify
            </a>
          </div>
        </div>
        <br />
        <p class="text-center text-body-secondary">
          © 2024 Anne Helene Nergård
        </p>
      </footer>
    </div>
  );
}

export default App;
